/**
 * @generated SignedSource<<9771962cdeb0e7898175fa31524296b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandMessageTaskActivateInput = {
  id: string;
};
export type BrandMessageTaskId_brandMessageTaskActivateMutation$variables = {
  input: BrandMessageTaskActivateInput;
};
export type BrandMessageTaskId_brandMessageTaskActivateMutation$data = {
  readonly brandMessageTaskActivate: {
    readonly id: string;
    readonly isActive: boolean;
  };
};
export type BrandMessageTaskId_brandMessageTaskActivateMutation = {
  response: BrandMessageTaskId_brandMessageTaskActivateMutation$data;
  variables: BrandMessageTaskId_brandMessageTaskActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandMessageTask",
    "kind": "LinkedField",
    "name": "brandMessageTaskActivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskId_brandMessageTaskActivateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTaskId_brandMessageTaskActivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0ae53dbb048385a2acc558b6545bb6d7",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskId_brandMessageTaskActivateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTaskId_brandMessageTaskActivateMutation(\n  $input: BrandMessageTaskActivateInput!\n) {\n  brandMessageTaskActivate(input: $input) {\n    id\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "a02afe8e8fb17f82ffc025cca11ec349";

export default node;
